import { Input } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import emailVerification from "../../assets/images/auth/email-verification.png";
import {
  activateAccount,
  getUserByEmail,
  resentOtp,
} from "../../actionCreator/signUpActionCreater";
import Gmail from "../../assets/images/auth/gmail.svg";
import Microsoft from "../../assets/images/auth/microsoft.png";
import { useAlert } from "../../context/AlertProvider";
import ChangeEmail from "./ChangeEmail";
import { getAccountInfo } from "../../actionCreator/commonActionCreator";
import { AuthContext } from "../../context/AuthContext";

const Verification = ({ email, activationKey }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { isAuthenticated, login } = useContext(AuthContext);
  const [error, setError] = useState();
  const [isChangeEmail, setChangeEmail] = useState(false);
  const getUserDetails = async () => {
    const user = await dispatch(
      getUserByEmail({ email: email.replace("@", "%40") })
    );
    if (user?.data?.activated) {
      navigate(isAuthenticated ? "/dashboard-view" : "/signin");
      showAlert(
        "warning",
        `The user with the email ${email} is already verified.`
      );
    }
  };

  useEffect(() => {
    if (email) {
      getUserDetails();
    }
  }, [email]);

  const onActivateAccount = async (otp) => {
    setError(null);
    if (otp && otp.length === 6) {
      const res = await dispatch(
        activateAccount({ activationKey, otp, email })
      );

      if (!!res?.data?.token) {
        login(res?.data?.token, false);
        dispatch(getAccountInfo(res?.data?.token));
        showAlert("success", "Your email has been verified successfully.");
        navigate("/dashboard-view");
      }
      if (
        res.response &&
        res.response.status >= 400 &&
        res.response.status <= 500
      ) {
        setError(res.response.data.title);
        showAlert("error", res.response.data.title);
      }
    } else {
      setError("Please Enter valid Code.");
    }
  };

  const onResendEmail = async () => {
    setError(null);
    const res = await dispatch(resentOtp({ email, activationKey }));
    if (res?.status === 200) {
      showAlert(
        "success",
        "A new OTP has been sent to your registered email address."
      );
    }
    if (
      res.response &&
      res.response.status >= 400 &&
      res.response.status <= 500
    ) {
      setError(res.response.data.title);
      showAlert("error", res.response.data.title);
    }
  };

  return (
    <div className="h-100 d-flex flex-column justify-content-center">
      <img
        src={emailVerification}
        width={100}
        style={{ maxWidth: 100 }}
        alt="Email Verification"
      />

      <h2 className="pt-2  my-2 heading32px fw-semibold">
        {isChangeEmail ? "Change email address" : "Verify your email address"}
      </h2>
      {isChangeEmail ? (
        <ChangeEmail
          email={email}
          activationKey={activationKey}
          callback={() => {
            setChangeEmail(false);
            setError(null);
          }}
        />
      ) : (
        <>
          <div className="text-gray-747474 heading14px mw420 pb-4 fw-semibold">
            We've just sent a 6-digit code to {email}
          </div>
          <Input.OTP
            length={6}
            onChange={(e) => {
              onActivateAccount(e);
            }}
          />
          {error && <p className="text-error text-left py-2">{error}</p>}
          <div className="d-flex">
            <Link
              to="https://mail.google.com/mail/u/0/#inbox"
              target="_blank"
              className="social-btn heading10px mt-3 d-flex align-items-center w-fit fw-semibold mr-4 text-black"
            >
              <img
                src={Gmail}
                alt="Gmail"
                width="20"
                height="20"
                className="mr-sm-2"
              />{" "}
              Open Gmail
            </Link>
            <Link
              to="https://outlook.office.com/mail/inbox"
              target="_blank"
              className="social-btn heading10px mt-3 d-flex align-items-center w-fit fw-semibold mr-4 text-black"
            >
              <img
                src={Microsoft}
                alt="Microsoft 365"
                width="20"
                height="20"
                className="mr-sm-2"
              />{" "}
              Open Microsoft 365
            </Link>
          </div>
          <div className="text-gray-747474 heading14px pt-4 fw-semibold">
            Haven’t seen the email? check you spam folder,{" "}
            <span
              className="text-theme fw-semibold cursor-pointer"
              onClick={onResendEmail}
            >
              resend
            </span>{" "}
            or{" "}
            <span
              className="text-theme fw-semibold cursor-pointer"
              onClick={() => setChangeEmail(true)}
            >
              change email
            </span>
            .
          </div>
        </>
      )}
    </div>
  );
};

export default Verification;
